/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_Li1Inputs */

const en_guide_json_syntax_errors_s6_li1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your JSON into the <a href="/json-formatter">JSON Formatter</a>: it will show the exact error location`)
};

const ko_guide_json_syntax_errors_s6_li1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON을 <a href="/json-formatter">JSON 포맷터</a>에 붙여넣으세요: 정확한 오류 위치를 보여줍니다`)
};

const ja_guide_json_syntax_errors_s6_li1 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONを<a href="/json-formatter">JSONフォーマッター</a>に貼り付けてください: 正確なエラー位置が表示されます`)
};

/**
* | output |
* | --- |
* | "Paste your JSON into the <a href=\"/json-formatter\">JSON Formatter</a>: it will show the exact error location" |
*
* @param {Guide_Json_Syntax_Errors_S6_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_li1 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_li1(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_li1(inputs)
	return ja_guide_json_syntax_errors_s6_li1(inputs)
});